import React, {Component} from 'react';
import {
  withGoogleReCaptcha
} from 'react-google-recaptcha-v3';
 
class ReCaptchaComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {token: ''}
    }
  
  componentDidMount() {
    const { executeRecaptcha } = (this.props)
      .googleReCaptchaProps;

    if (!executeRecaptcha) {
      console.log('Recaptcha has not been loaded');

      return;
    }
    executeRecaptcha(this.props.component)
    .then(token => {
      this.setState({token: token})
      if (!!this.props.handler) {
        this.props.handler({captcha_token: token})
      }
    })
    .catch(error => {
      console.log("Error ReCaptcha: ", error);
    })
  }
 
  render() {
    return (

      <input type="hidden" value={this.state.token} />

    );
  }
}
 
export default withGoogleReCaptcha(ReCaptchaComponent);